/* Shared Storefront variant fetch for the PDP.
 * product-form.liquid and product-images-new.liquid both need the same variant list
 * with the same metafields, so the query lives here once and the promise is shared.
 */
(function () {
  if (window.liveVariants) return;

  const STOREFRONT_TOKEN = 'ed761c0d0f68bc596e5e4dd4e29e6407';
  const SHOP_DOMAIN = 'live-ecom.myshopify.com';

  async function fetchAllVariants(handle) {
      let all = [];
      let cursor = null;
      let hasNext = true;

      while (hasNext) {
      const query = `
          query ($handle: String!, $cursor: String) {
              product(handle: $handle) {
                  variants(first: 250, after: $cursor) {
                      edges {
                          cursor
                          node {
                              id
                              availableForSale
                              sku
                              selectedOptions {
                                  name
                                  value
                              }
                              price {
                                  amount
                                  currencyCode
                              }
                              compareAtPrice {
                                  amount
                                  currencyCode
                              }
                              active: metafield(namespace: "custom", key: "active") {
                                  value
                                  type
                              }
                              progressiveSale: metafield(namespace: "custom", key: "progressive_sale") {
                                  value
                              }
                              images: metafield(namespace: "custom", key: "images") {
                                  type
                                  references(first: 20) {
                                      edges {
                                          node {
                                              __typename
                                              ... on MediaImage {
                                                  image {
                                                      url
                                                      altText
                                                      width
                                                      height
                                                  }
                                              }
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      pageInfo {
                          hasNextPage
                      }
                  }
              }
          }
      `;

      const res = await fetch(
          `https://${SHOP_DOMAIN}/api/2025-07/graphql.json`,
          {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({
              query,
              variables: { handle, cursor }
          })
          }
      );

      if (!res.ok) throw new Error(`Storefront variants request failed: ${res.status}`);

      const json = await res.json();
      const variants = json.data?.product?.variants;
      if (!variants) throw new Error('Storefront variants response carried no product');

      variants.edges.forEach(edge => {
          all.push(edge.node);
          cursor = edge.cursor;
      });

      hasNext = variants.pageInfo.hasNextPage;
      }

      return all;
  }
  const cache = {};

  window.liveVariants = {
    get: function (handle) {
      if (!handle) return Promise.resolve([]);
      if (!cache[handle]) {
        cache[handle] = fetchAllVariants(handle);
        // never keep a rejection: the next caller must be able to retry
        cache[handle].catch(function () { delete cache[handle]; });
      }
      return cache[handle];
    }
  };
})();
